<div
  id="step-confirm-health-system-selection"
  class="flex h-full min-h-0 flex-col overflow-hidden"
>
  <ng-container *ngIf="configService.vaultProfileConfigSubject | async as vaultProfile">
    <div class="flex min-h-0 flex-1 flex-col pt-6">
      <div>
        <h2 class="fdk-type-heading-2 text-fdk-primary">
          Review and confirm 
        </h2>
        <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
          Check the providers you've selected, then confirm to share your records.
        </p>
        <p
          id="connected-account-count"
          class="fdk-type-paragraph-s text-fdk-accent mt-fdk-m"
        >
          {{ (vaultProfile.connectedPatientAccounts || []).length }} provider{{ (vaultProfile.connectedPatientAccounts || []).length === 1 ? '' : 's' }} selected
        </p>
      </div>

      <div
        id="connected-account-cards"
        class="flex min-h-0 flex-1 flex-col gap-fdk-xxs overflow-y-auto mt-fdk-xs no-scrollbar"
      >
        <fdk-card
          *ngFor="let connectedAccount of vaultProfile.connectedPatientAccounts || []"
          class="connected-account-card flex-shrink-0"
          [title]="connectedAccount.portal?.name || connectedAccount.brand?.name || ''"
          [initials]="
            getAccountInitials(connectedAccount.portal?.name || connectedAccount.brand?.name || '')
          "
          [logo]="getAccountLogo(connectedAccount.brand?.id)"
          variant="readOnly"
        />
      </div>

      <div class="confirm-selection-footer mt-auto pt-6 flex-shrink-0">
        <p class="fdk-type-paragraph-xs text-fdk-secondary mb-fdk-xs">
          Your health records are encrypted and will only be shared with
          {{ (configService.systemConfigSubject | async)?.companyName || (configService.systemConfigSubject | async)?.org?.name || "Unknown" }}.
        </p>
        <fdk-button
          id="share-records"
          type="button"
          variant="primary"
          width="full"
          [disabled]="!(vaultProfile.connectedPatientAccounts || []).length || isCompleting"
          (click)="completeAccounts()"
        >
          <span class="flex items-center justify-center gap-2"
            ><fdk-spinner *ngIf="isCompleting" /> Share my records</span
          >
        </fdk-button>
      </div>
    </div>
  </ng-container>
</div>
